import { render } from "./perfilES.vue?vue&type=template&id=2fe7d39c&scoped=true"
import script from "./perfilES.vue?vue&type=script&lang=js"
export * from "./perfilES.vue?vue&type=script&lang=js"

import "./perfilES.vue?vue&type=style&index=0&id=2fe7d39c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe7d39c"]])

export default __exports__